(function() { window.GUID_ce673ccb_af8f_43a0_93db_f184a438ca22 = { getGuid: function() { return "ce673ccb-af8f-43a0-93db-f184a438ca22"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let OpponentType;
        (function (OpponentType) {
            OpponentType[OpponentType["Single"] = 0] = "Single";
            OpponentType[OpponentType["Double"] = 1] = "Double";
            OpponentType[OpponentType["Triple"] = 2] = "Triple";
            OpponentType[OpponentType["Team"] = 4] = "Team";
        })(OpponentType = Enumeration.OpponentType || (Enumeration.OpponentType = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=OpponentType.pre.js.map
